<div class="tooltip-container" role="tooltip">
  <ng-template #simpleText>
    {{ text }}
  </ng-template>
  <ng-container *ngTemplateOutlet="contentTemplate || simpleText"> </ng-container>
</div>
